import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AddAccommodationsModal from 'src/components/global-settings/AddAccommodationsModal'
import { createVehicleCreateAccomodations, getVehicleCreateAccomodations } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleAccomodation: (name: string) => {
      return new Promise((approve, reject) => {
        dispatch(createVehicleCreateAccomodations(name)).then(() => {
          dispatch(getVehicleCreateAccomodations()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateAccomodations: () => dispatch(getVehicleCreateAccomodations())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddAccommodationsModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddAccommodationsModal.ts